'use strict';
import getUrls from './getUrls';
import routerUtility from 'utils/routerUtility';
import ModuleAccessCodes from 'constants/moduleCodes';
import RoutePath from 'constants/routePath';
import accountStore from 'store/accountStore';
import RouterRedirect from 'utils/RouterRedirect';
import { ImprovementHubLoader } from './loader';
import { handleLazyLoadError } from '../../helper/error-helper';


module.exports = {
  path: getUrls.getModuleUrl(),

  getIndexRoute(partialNextState, callback) {
    require.ensure([], function (require) {
      if (accountStore.isGovernorOnly()) {
        callback(new RouterRedirect(getUrls.getTasksFilterUrl()));
      }
      callback(null, {
        component: require('./views/home/homePage').default,
      });
    })
  },

  getComponent(nextState, callback) {
    var error = routerUtility.getAccessError(ModuleAccessCodes.MODULE_INSPECTION_CENTRE);
    if (error === null) {
      ImprovementHubLoader.load(callback).catch(handleLazyLoadError);
    } else {
      callback(error);
    }
  },

  getChildRoutes(partialNextState, callback) {
    require.ensure([], function (require) {
        callback(null, [
          {
            path: RoutePath.ROUTE_INSPECTION_TASKS,
            component: require('./views/tasks/tasksPageRoot').default,
            childRoutes: [
              {
                path: `filter/:id`,
                component: require('./views/tasks/tasksPage').default
              },
              {
                path: `filter/:id/reports`,
                component: require('./views/reports/reportsPage').default
              }
            ]
          },
          {
            path: `${RoutePath.ROUTE_INSPECTION_TASKS}/:id`,
            component: require('./views/task/taskPage').default
          },
          {
            path: RoutePath.ROUTE_INSPECTION_CENTRE_FILTERS_AND_NOTIFICATIONS,
            component: require('./views/filtersAndNotifications/FiltersAndNotificationsPage').default
          },
          {
            path: RoutePath.ROUTE_INSPECTION_CENTRE_CONFIGURE_PLAN,
            component: require('./views/configurePlan/configurePlanPage').default
          },
          {
            path: RoutePath.ROUTE_MY_PROFILE,
            component: require('../../component/profile/profilePage')
          },
          {
            path: RoutePath.ROUTE_NOT_FOUND,
            component: require('../../component/errors/notFoundPage')
          }
        ])
      },
      handleLazyLoadError,
      'improvement-hub'
      );
  }
};
